<template>
  <div class="view-container">
    <div class="content" style="padding-bottom:50px;">
        <!-- @using (Html.BeginForm("UpdatePassword", "Accounts", new { area = "Orders" }, FormMethod.Post, new { data_toggle = "validator" }))
        { -->
        <form name="PasswordChange">
            <br />
            <div class="row">
                <span>
                    Update the password for your <strong>Online Ordering Account</strong>.
                </span>
                <br />
                <span>
                    <strong>Note:</strong> This will be used to login to your account.
                </span>
            </div>
            <br />
            <div class="row form-group">
                <label class="control-label col-xs-12">Old Password</label>
                <div class="input-group col-xs-12">
                    <span class="input-group-addon"><i class="fa fa-lock fa-fw"></i></span>
                    <input type="password" id="oldPassword" name="OldPassword" data-minlength="6" class="form-control" data-error="A password with a minumum of 6 characters must be supplied." required />
                </div>
                <div class="help-block with-errors"></div>
            </div>
            <div class="row form-group">
                <label class="control-label col-xs-12">New Password</label>
                <div class="input-group col-xs-12">
                    <span class="input-group-addon"><i class="fa fa-lock fa-fw"></i></span>
                    <input type="password" id="inputPassword" name="Password" data-minlength="6" class="form-control" data-error="A password with a minumum of 6 characters must be supplied." required />
                </div>
                <div class="help-block with-errors"></div>
            </div>
            <div class="row form-group">
                <label class="control-label col-xs-12">Confirm password</label>
                <div class="input-group col-xs-12">
                    <span class="input-group-addon"><i class="fa fa-lock fa-fw"></i></span>
                    <input type="password" name="ConfirmPassword" class="form-control" data-match="#inputPassword" data-match-error="Oops. It seems the passwords do not match." required />
                </div>
                <div class="help-block with-errors"></div>
            </div>
            <div class="row form-group">
                <button type="submit" name="Activate" class="btn btn-success pull-right">Activate</button>
            </div>
        <!-- } -->
        </form>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import { view } from "./PasswordChange.vue.js";

export default {
  name: "PasswordChange",
  components: {
  },
  mixins: [view],
  data() {
    return {}
  },
  created() {
    if(this.$franchiseID == null){
        this.$router.push('Franchise');
    }
    if(localStorage.userMembershipID == null){
      this.$router.push({ path: 'Login', query: { returnUrl: "Profile" }});
    }
  },
  mounted() {
      document.querySelector('button[name=Activate]').addEventListener("click", this.submit);
  }
};
</script>
